module.exports = __webpack_public_path__ + "static/carlife-e0fa96415b93825b2c13662a05b3ef70.jpg";